import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { getColumnKey, getRowKey } from '../../../utils/componentHelper'
import {
  DenseTableRowProps,
  CellProps,
  ContentProps,
  TableStylingProps
} from '../types'
import { CellContent } from './cell-content'

const useStyles = makeStyles((theme) => {
  const { mobileColumnBox, table } = theme.variables.colors

  return {
    mobileAlertCard: {
      backgroundColor: table.alert
    },
    mobileColumnBox: ({
      addBorderToFirstMobileColumnBox
    }: TableStylingProps) => {
      const firstOfTypeProps = {
        '&:first-of-type': addBorderToFirstMobileColumnBox
          ? {
              borderTop: `.12rem solid ${mobileColumnBox.borderTopFirst}`,
              marginTop: '.5rem'
            }
          : {
              paddingTop: '0px'
            }
      }

      return {
        alignItems: 'stretch',
        borderBottom: `1px solid ${mobileColumnBox.borderBottom}`,
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        flexShrink: 1,
        justifyContent: 'flex-start',
        marginLeft: '4px',
        marginRight: '4px',
        paddingBottom: '12px',
        paddingTop: '12px',
        ...firstOfTypeProps,
        '&:last-of-type': {
          borderBottom: `.12rem solid ${mobileColumnBox.borderBottomLast}`,
          marginBottom: '2.5rem'
        },
        [theme.breakpoints.up('md')]: {
          paddingBottom: '1rem',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          paddingTop: '1rem'
        }
      }
    }
  }
})

export const MobileContent = <RowDataType,>({
  data,
  filtered,
  tableStylingProps,
  ...rest
}: ContentProps<RowDataType>) => {
  const addBorderToFirstMobileColumnBox =
    tableStylingProps?.addBorderToFirstMobileColumnBox
  const classes = useStyles({ addBorderToFirstMobileColumnBox })

  return (
    <>
      {data.map((row: DenseTableRowProps<RowDataType>, rowIndex: number) => {
        const alertClass = row.addAlertClass ? classes.mobileAlertCard : ''
        return (
          <Box
            key={getRowKey('B', rowIndex)}
            className={`${classes.mobileColumnBox} ${alertClass}`}
          >
            {filtered.map(
              (cellProps: CellProps<RowDataType>, cellIndex: number) => {
                return (
                  <CellContent
                    key={getColumnKey('C', rowIndex, cellIndex)}
                    {...{ ...rest, index: rowIndex }}
                    isMobile={true}
                    row={row}
                    cellProps={cellProps}
                  />
                )
              }
            )}
          </Box>
        )
      })}
    </>
  )
}
